import { useState } from 'react';
import Image from 'next/legacy/image';
import { Loading } from 'components/new-components/Loading';
import { CLASS_TRACKING_GTM, DEFAULT_IMAGE } from 'constants/index';
import * as El from './CollectionCard.css';

type ImageUrls = {
  icon?: string;
  normal?: string;
  banner?: string;
  iconActive?: string;
  darkNormal?: string;
  web?: string;
}

interface CollectionCardProps {
  isLoading?: boolean;
  images: ImageUrls;
  label: string;
  fullSize?: boolean;
  href?: string;
  collection_id?: string;
  sectionPosition?: string;
  dataCreative?: string;
  loadingImage?: 'lazy' | 'eager'
}

function CollectionCard({
  isLoading = false,
  images,
  label = '',
  fullSize = false,
  href = '#',
  collection_id,
  sectionPosition,
  dataCreative,
  loadingImage = 'eager',
}: CollectionCardProps) {
  const [hasClicked, setHasClicked] = useState(false);
  return (
    <a
      id="collection-card"
      className={`${CLASS_TRACKING_GTM.COLLECTION_CARD} ${El.CardContainer}`}
      href={href}
      title={label}
      aria-label={label}
      onClick={() => setHasClicked(true)}
      data-bannerid={`${collection_id}`}
      data-name={`${label}`}
      data-position={`${sectionPosition || ''}`}
      data-creative={dataCreative}
      target="_top"
      style={{ filter: isLoading ? 'none' : '' }}
    >
      <div className={El.ImageContainer[fullSize ? 'fullSize' : 'defaultSize']}>
        <div className={El.ContentWrapper[fullSize ? 'fullSize' : 'base']}>
          {hasClicked && (
            <div className={El.CollectionCardLoading}>
              <Loading />
            </div>
          )}
          <Image
            src={images.icon || images.banner || DEFAULT_IMAGE}
            width={46}
            height={46}
            alt={label}
            loading={loadingImage}
            priority={loadingImage === 'eager'}
          />
          <div className={El.CollectionName[fullSize ? 'fullSize' : 'base']}>
            <h3>{label}</h3>
          </div>
        </div>
      </div>
    </a>
  );
}

export default CollectionCard;
